<mat-sidenav-container>
  <mat-sidenav
    class="main row create_watch_list"
    #sidenav
    mode="over"
    position="end"
    [opened]="createWatchListSheetActive"
    disableClose
  >
    <div class="sliding-sheet-header">
      <h4>New Watchlist</h4>
      <button type="button" (click)="closeCreateWatchListSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="slidesheetcontent">
      <form #formDirective="ngForm" [formGroup]="watchListForm" (ngSubmit)="addToWatchList(formDirective)">
        <div class="row mb-4">
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field class="w-100">
              <mat-label> {{ stringRes.WATCH_LIST }} Name </mat-label>
              <input matInput autocomplete="off" placeholder="Watchlist Name" formControlName="watchListName" />
              <mat-error
                *ngIf="
                  watchListFormValidation.watchListName.errors && watchListFormValidation.watchListName.errors.required
                "
                class="invalid-feedback"
                >{{ stringRes.WATCH_LIST }} name is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <app-contact-table
          [csvFileColumnList]="csvFileColumns"
          [csvRecordColumnList]="csvRecordColumns"
          [filter]="filter"
          [externalSelectedId]="selectedIdList"
          (selectedRecordsEvent)="selectedRecords($event)"
        >
        </app-contact-table>

        <div class="row mt-4">
          <!-- <div class="col-sm-9 text-right">
            <p>You have selected <strong>{{ selectedRecordCount }}</strong> records!</p>
          </div> -->
          <div class="col-sm-12">
            <p class="d-inline-block mt-1">
              You have selected <strong>{{ selectedRecordCount }}</strong> records!
            </p>
            <button
              class="float-right ml-3"
              mat-flat-button
              color="primary"
              type="submit"
              [pmx-progress-button]="addToWatchListInProgress"
            >
              Create {{ stringRes.WATCH_LIST }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
